<script setup lang="ts">
import { STORYBLOK_HOMEPAGE_STORY_DEFAULT_FULL_SLUG, STORYBLOK_ROUTES } from '#shared/constants/storyblok';

definePageMeta({
    middleware: to => {
        // There is no index page: the homepage is served by this catch-all, which therefore also matches the
        // localized root, where the slug param is absent
        const slugString = (Array.isArray(to.params.slug) ? to.params.slug.join('/') : to.params.slug) ?? '';

        if (slugString === STORYBLOK_HOMEPAGE_STORY_DEFAULT_FULL_SLUG) {
            return navigateTo(STORYBLOK_ROUTES.HOMEPAGE);
        } else if (slugString.startsWith('templates/')) {
            throw createError({ status: 404 });
        }
    },
});

// COMPOSABLES
const route = useRoute();
const { apiOptions } = useStoryblokApiParams({ resolve_relations: 'storyblok-blog-post.categories' });

// DATA
const { story, error } = await useStoryblokAsyncData(resolveStoryblokSlug(route.params.slug), {
    api: apiOptions,
    bridge: {},
});
useStoryblokProvideStoryMeta(story);

if (!story.value || error.value) {
    throw createError({ status: 404 });
}

// TRACKING
const { setStoryblokPageType } = useStoryblokTrackingPageType();
setStoryblokPageType(story.value.full_slug);

// SEO
useStoryblokSeoMeta(story);
</script>

<template>
    <StoryblokComponent v-if="story" :blok="story.content" />
</template>
